import React, { FunctionComponent, useState } from "react";
import { useNavigate } from "react-router-dom";
import MaterialTable, { Column } from "@material-table/core";
import { UserOrder, UserOrderState as State } from "../../../../models/User";
import { UserOrderState } from "../../components/UserOrderState";
import moment from "moment";
import useStyles from "../styles";
import { useI18n } from "../../../../hooks/useI18n";

interface Row {
  id: string;
  userName: string;
  state: State;
  created: Date;
  deadline?: Date;
}

interface TableState {
  columns: Array<Column<Row>>;
  data: Row[];
}

interface OrdersTableProps {
  storeId: string;
  orders: ReadonlyArray<UserOrder>;
}

export const OrdersTable: FunctionComponent<OrdersTableProps> = ({
  storeId,
  orders
}) => {
  const { t } = useI18n();
  const classes = useStyles();
  const navigate = useNavigate();
  const generateState = (orders: ReadonlyArray<UserOrder>): TableState => {
    return {
      columns: [
        {
          title: "Created",
          field: "created",
          render: rowData => moment(rowData.created).format("YYYY-MM-DD HH:mm")
        },
        {
          title: "Deadline",
          field: "deadline",
          render: rowData => (
            <span
              className={
                rowData.deadline && moment(rowData.deadline) < moment()
                  ? classes.deadlinePassed
                  : undefined
              }
            >
              {rowData.deadline
                ? moment(rowData.deadline).format("YYYY-MM-DD HH:mm")
                : "..."}
            </span>
          )
        },
        {
          title: "State",
          field: "state",
          render: rowData => <UserOrderState state={rowData.state} />
        },
        { title: "User", field: "userName" }
      ],
      data:
        orders && orders.length
          ? orders.map(order => ({
              id: order.id,
              userName: `${order.user.firstName} ${order.user.lastName}`,
              state: order.state,
              created: order.created,
              deadline: order.deadline
            }))
          : []
    };
  };

  const [state, setState] = useState<TableState>(generateState(orders));

  return (
    <>
      <MaterialTable
        title={t("common.messages.orders")}
        columns={state.columns}
        data={state.data}
        onRowClick={(event, row) => {
          if (!row) {
            return;
          }
          return navigate(`/stores/${storeId}/user-orders/${row.id}`);
        }}
        options={{
          search: false,
          pageSize: 10
        }}
      />
    </>
  );
};
